export const EMAIL_MIN_LENGTH = 5;
export const EMAIL_MAX_LENGTH = 254;
export const DISPLAY_NAME_MIN_LENGTH = 2;
export const DISPLAY_NAME_MAX_LENGTH = 60;

export const CURRENT_TERMS_VERSION = '2026-08-20';

export function isValidEmailInput(raw: string): boolean {
	const value = raw.trim();
	if (value.length < EMAIL_MIN_LENGTH || value.length > EMAIL_MAX_LENGTH) return false;
	const separator = value.lastIndexOf('@');
	if (separator <= 0 || separator !== value.indexOf('@')) return false;
	const local = value.slice(0, separator);
	const domain = value.slice(separator + 1);
	if (local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;
	if (!/^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/iu.test(local)) return false;
	const labels = domain.split('.');
	if (labels.length < 2 || labels.at(-1)!.length < 2) return false;
	return labels.every((label) => label.length >= 1 && label.length <= 63 && /^[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?$/iu.test(label));
}
